import React, { useState } from 'react';
import { IonContent, IonModal, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { ApiService } from '../api/ApiService';
import { toastStore } from '../components/AppToast';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';

function RegisterPlate() {
  const history = useHistory();
  const { onSheet, onIonScroll } = useTransparentHeaderContrast();
  const [number, setNumber] = useState('');
  const [confirming, setConfirming] = useState(false);
  const [mounted, setMounted] = useState(false);

  React.useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  function submitPlateInfo() {
    ApiService.vehicleRegister('registerPlate', { plateNumber: number.replace('-', '') })
      .then(() => {
        toastStore.getState().setSuccessToast('Your license plate is now registered. Thank you!');
      })
      .finally(() => {
        setConfirming(false);
        setNumber('');
      });
  }

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.replace('/Home');
  };

  const plateValue = number.replace('-', '');

  return (
    <IonPage>
      <LoadDetailHeader title="Register Vehicle" onBack={goBack} onSheet={onSheet} />

      <IonModal
        isOpen={confirming}
        cssClass="profile-shirt-modal"
        onDidDismiss={() => setConfirming(false)}
      >
        <div className="profile-shirt-modal__backdrop" onClick={() => setConfirming(false)}>
          <div
            className="profile-shirt-modal__card"
            role="dialog"
            aria-modal="true"
            aria-labelledby="register-plate-modal-title"
            onClick={e => e.stopPropagation()}
          >
            <div className="profile-shirt-modal__header" id="register-plate-modal-title">
              Confirm plate
            </div>
            <p className="profile-shirt-modal__body">
              Register <strong>{plateValue}</strong> as your personal vehicle plate?
            </p>
            <button type="button" className="profile-shirt-modal__close" onClick={() => submitPlateInfo()}>
              Yes, register
            </button>
            <button
              type="button"
              className="profile-shirt-modal__secondary"
              onClick={() => setConfirming(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </IonModal>

      <IonContent
        fullscreen
        className="design-a-content design-a-content--light"
        scrollEvents={true}
        onIonScroll={onIonScroll}
      >
        <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
          <div className="home-hero advance-hero">
            <div className="advance-hero__eyebrow">As needed</div>
            <div className="advance-hero__title home-display">Personal Vehicle</div>
            <div className="advance-hero__meta">Register your plate at a terminal</div>
          </div>

          <div className="home-sheet advance-sheet">
            <div className="advance-card">
              <div className="advance-card__title">License plate</div>
              <p className="advance-card__body">
                Register your license plate when you leave a vehicle at one of the terminals.
              </p>
              <div className="profile-fields">
                <label className="profile-field">
                  <span className="profile-field__label">Plate number</span>
                  <input
                    className="profile-field__input"
                    id="register"
                    type="text"
                    value={number}
                    onChange={e => setNumber(e.target.value.toLocaleUpperCase())}
                    placeholder="ABC1234"
                  />
                </label>
                <button
                  type="button"
                  className="profile-submit"
                  disabled={!plateValue}
                  onClick={() => setConfirming(true)}
                >
                  Submit registration
                </button>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}

export default RegisterPlate;
